import { t } from "i18next";

import { FieldBuilder } from "../../formBuilder/index.js";
import {
  responsibleCustodyForceSchema,
  shortTextSchema,
} from "../../types/index.js";
import { tk } from "../../types/Translation.js";
import { responsibleCustodyForceOptions } from "../common/custodySuite.js";
import {
  buildMcaIncidentDetailsSharedFields,
  railwayLocationTypeOptions,
} from "../common/mcaIncidentDetails.js";

/**
 * British Transport Police hold people in whichever force's custody suite is
 * nearest on the rail network, so the suite cannot come from a fixed list. It
 * is recorded by name, together with the force accountable for that suite.
 *
 * The rail network is not confined to London, so the London borough question is
 * not composed here, and the locations offered are those of a railway rather
 * than those of a city.
 */
export const formSpecification = buildMcaIncidentDetailsSharedFields({
  locationTypeOptions: railwayLocationTypeOptions,
})
  .withFieldConditionallyVisible({
    fieldName: "custodySuiteName",
    type: "textbox",
    ...new FieldBuilder().withSchema(shortTextSchema).build(),
    label: tk("custodySuite.name"),
    requiredLabel: tk("custodySuite.nameRequired"),
    isVisible: ({ formValues }) =>
      formValues.locationType?.value === "policeStationsCustody",
  })
  .withFieldConditionallyVisible({
    fieldName: "policeForceResponsibleForCustodySuite",
    type: "dropdown",
    ...new FieldBuilder()
      .withSchema(responsibleCustodyForceSchema)
      .captureValueLabel()
      .build(),
    label: tk("custodySuite.responsibleForce.title"),
    requiredLabel: tk("custodySuite.responsibleForce.required"),
    options: responsibleCustodyForceOptions,
    isVisible: ({ formValues }) =>
      formValues.locationType?.value === "policeStationsCustody",
  })
  .withPage(["dateTimeOfIncident"])
  .withPage(["incidentLocation"])
  .withPage(["bcuIncidentTookPlace"])
  .withPage(["locationType"])
  .withPage([
    "custodyNumber",
    "custodyNumberDescriptionBanner",
    "custodySuiteName",
    "policeForceResponsibleForCustodySuite",
  ])
  .build({ t });

export type McaIncidentDetailsFormData = ReturnType<
  typeof formSpecification
>["formType"];
